import { useEffect, useRef } from 'react'

import type { TableCheckboxProps } from './TableCheckbox.types'

export const TableCheckbox = (props: TableCheckboxProps) => {
  const { checked, indeterminate, onChange, 'aria-label': ariaLabel } = props
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = !!indeterminate
    }
  }, [indeterminate])

  return (
    <input
      ref={ref}
      aria-label={ariaLabel}
      checked={checked}
      className="TableCheckbox"
      onChange={onChange}
      type="checkbox"
    />
  )
}
